// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_cHv","cls2":"CitingSourcesCard-cls2_IXn CitingSourcesCard-cls1_cHv"};